module.exports = __webpack_public_path__ + "img/CBD Products.cd26fba8.jpg";